import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import { getPaletteColor } from './colors';
import type { DialogColor, DialogVariant } from './types';

const variants = {
  standard: css`
    padding-top: var(--cds-spacing-300);
    padding-inline-end: var(--cds-spacing-100);
    padding-inline-start: var(--cds-spacing-300);
    padding-bottom: var(--cds-spacing-200);

    ${breakpoints.down('xs')} {
      padding-inline-start: var(--cds-spacing-200);
      padding-bottom: var(--cds-spacing-150);
    }
  `,

  transactional: css`
    padding-top: var(--cds-spacing-300);
    padding-inline-start: var(--cds-spacing-300);
    padding-inline-end: var(--cds-spacing-300);
    padding-bottom: var(--cds-spacing-200);

    ${breakpoints.down('xs')} {
      padding-inline-start: var(--cds-spacing-200);
      padding-inline-end: var(--cds-spacing-200);
      padding-bottom: var(--cds-spacing-150);
    }
  `,

  sticky: css`
    position: sticky;
    top: 0;
  `,
};

export const getHeadingGroupCss = ({
  color,
  variant,
  sticky,
}: {
  color: DialogColor;
  variant: DialogVariant;
  sticky: boolean;
}) => {
  // Border and margin are to fix a sub-pixel rendering issue where a
  // small gap is present between the heading group and the Dialog header
  return css`
    grid-area: headingGroup;
    background-color: ${getPaletteColor(color)};

    ${breakpoints.down('xs')} {
      border-radius: 0;
    }

    ${variants[variant]}

    ${sticky && variants.sticky}
  `;
};
